import ViewTripOrder from "../../../../components/@documents/trip_orders/ViewTripOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TripOrderViewPage() {

    return (
        <ViewTripOrder 
            routeType={routeTypes.admin}
        />
    )
}